import { createContext } from 'react';
var IndexContext =
/*#__PURE__*/
createContext(undefined);
var IndexSelectionChangeContext =
/*#__PURE__*/
createContext(undefined);
var IndexRowContext =
/*#__PURE__*/
createContext(undefined);
export { IndexContext, IndexRowContext, IndexSelectionChangeContext };